import { Profile } from "~/features/profile/index.tsx";

export const ProfilePage = () => {
	return <Profile />;
};
